import { Component } from 'vue-property-decorator';
import PriceCategoryTable from '@contacts/components/tables/price-category-table/price-category-table.vue';
import Vue from 'vue';

@Component({
  name: 'bpc-price-categories',
  components: {
    'bpc-price-category-table': PriceCategoryTable,
  },
})
export default class PriceCategories extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
